import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Process from "@/components/landing/Process";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import ScrollToTop from "@/components/landing/ScrollToTop";
import ChatWidget from "@/components/landing/ChatWidget";

const Index = () => (
  <div className="min-h-screen" style={{ overflowX: 'clip' }}>
    <Header />
    <main>
      <Hero />
      <Services />
      <WhyChooseUs />
      <Process />
      <Contact />
    </main>
    <Footer />
    <ScrollToTop />
    <ChatWidget />
  </div>
);

export default Index;
